import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { RegistrationService } from '../registration/registration.service';
import { claimTypes } from 'src/app/appsettings';
import moment from 'moment';

export const registrationPrivateCompleteDetailsGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const registrationService = inject(RegistrationService);
  const email = (route.queryParamMap.get('email') || '').replace(/ /g, '+');
  const userId = route.queryParamMap.get('userId') || '';
  const synlabId = route.queryParamMap.get('synlabId') || '';
  const fiscalCode = route.queryParamMap.get('fiscalCode') || '';
  const dateOfBirth = route.queryParamMap.get('dateOfBirth') || '';
  const fromActivation = route.queryParamMap.get('fromActivation')?.toLowerCase() === 'true';

  if (!userId || !synlabId) return false;

  const formatDOB = (dateOfBirth: string) => {
    const formattedDOB = moment(dateOfBirth).isValid() ? moment(dateOfBirth).format('DD.MM.YYYY') : '';;

    if (formattedDOB) {
      return formattedDOB;
    }
    return '';
  }

  registrationService.registeredUserData.set({
    userId,
    synlabId,
  });

  const userInfo = {
    confirmPassword: '',
    date_of_birth: dateOfBirth,
    email,
    noFiscalCode: !fiscalCode,
    password: '',
    [claimTypes.FISCAL_CODE]: fiscalCode,
    
  };

  if (fromActivation) {
    registrationService.fromActivation.set(fromActivation);
    registrationService.personalInfoCache.set({
      ...userInfo,
      date_of_birth: formatDOB(dateOfBirth),
    } as any);
  }
  
  registrationService.personalInfo.set(
    userInfo as any // eslint-disable-next-line @typescript-eslint/no-explicit-any
  );

  return true;
};
